'use strict';

const classnames = require('classnames');
const React = require('react');
const PropTypes = require('prop-types');
const inViewport = require('in-viewport');
const scrollIntoView = require('scroll-into-view');
const SanitizeHtml = require('../../global/components/SanitizeHtml');
const ContextComponent = require('../../global/components/ContextComponent');
const ArrowRightIcon = require('dibs-vg/dist/react/arrow-right');
const style = require('./tour.scss');

const Tooltip = require('dibs-react-tooltip');
require('dibs-react-tooltip/dist/main.css');

const tradeTourActions = require('./tourActions');

class Tour extends ContextComponent {

    constructor(props) {
        super(props);

        this.onClose = this.onClose.bind(this);
        this.onCtaClick = this.onCtaClick.bind(this);

        const isOpen = props.isTourOpen && props.step === props.currentStep;

        this.state = {
            isOpen: isOpen,
            isVisible: isOpen
        };
    }

    componentDidMount() {
        const {isOpen} = this.state;

        if (isOpen) {
            this.onOpen();
        }
    }

    componentWillReceiveProps(nextProps) {
        const {step, currentStep, isTourOpen} = nextProps;

        if (isTourOpen && step === currentStep) {
            this.setState({isOpen: true});
            this._showTour();
        } else {
            this.setState({isVisible: false});
            this._closeTour();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.isOpen && this.state.isOpen) {
            this.onOpen();
        }
    }

    onOpen() {
        const {type, subType, step, onOpen} = this.props;
        onOpen({type, subType, step});
    }

    _notInView() {
        return this._tourStep && !inViewport(this._tourStep);
    }

    _showTour() {
        const {duration} = this.props;
        let timeout = 0;

        if (this._notInView()) {
            scrollIntoView(this._tourStep, {time: duration});
            timeout = duration;
        }

        this._clearTimeouts();
        this._timeout = setTimeout(() => this.setState({isVisible: true}), timeout);
    }

    _closeTour() {
        const {duration} = this.props;
        this._clearTimeouts();
        this._timeout = setTimeout(() => this.setState({isOpen: false}), duration ? 200 : 0);
    }

    _clearTimeouts() {
        clearTimeout(this._timeout);
    }

    onClose(event) {
        event.preventDefault();
        const {type, subType, step, onClose} = this.props;
        this.context.executeAction(tradeTourActions.closeTour, {type});
        onClose({type, subType, step});
    }

    onCtaClick(event) {
        event.preventDefault();

        const {type, subType, step, totalSteps, onCtaClick} = this.props;
        let action;

        if (step === totalSteps) {
            action = tradeTourActions.closeTour;
        } else {
            action = tradeTourActions.increaseStep;
        }

        this.context.executeAction(action, {type});
        onCtaClick({type, subType, step});
    }

    getSvgArrow(hasNext) {
        if (hasNext) {
            return <ArrowRightIcon className="button-icon" />;
        }

        return null;
    }

    getCancel(copy) {
        if (copy.cancel) {
            return (
                <a className={style.cancel} onClick={this.onClose} href="#0">
                    {copy.cancel}
                </a>
            );
        }

        return null;
    }

    getCopy() {
        const {step, copy, subType} = this.props;
        const stepCopy = copy[`step${step}`];

        return stepCopy && stepCopy[subType] || stepCopy || {};
    }

    getHeader(copy) {
        if (copy.header) {
            return (
                <div className={style.header}>
                    <SanitizeHtml content={copy.header} />
                </div>
            );
        }

        return null;
    }

    render() {
        const {isOpen, isVisible} = this.state;
        const {step, totalSteps, className, duration, type, dataTn} = this.props;
        const copy = this.getCopy();
        const hasNext = step < totalSteps;
        const ctaClassName = classnames('button-primary button-small', style.cta, {
            'has-icon-right': hasNext
        });
        const tooltipClassName = classnames(style.tooltip, {
            [style.visible]: isVisible
        });

        const ctaWrapperClass = classnames(style.ctaWrapper, {
            [style.hasCancel]: copy.cancel
        });

        return (
            <span
                ref={tourStep => { this._tourStep = tourStep; }}
                className={`${style.wrapper} ${className}`}
                data-tn={`tour-${dataTn}`}
            >
                {this.props.children}
                <Tooltip
                    isVisible={isOpen}
                    data-tn={`tour-tooltip-${type}`}
                    className={tooltipClassName}
                    containerClass={style.container}
                    tooltipDirection="left"
                    hasClose
                    debounce={this._notInView() ? duration : 0}
                    closeClass={style.close}
                    onCloseClick={this.onClose}
                >
                    {this.getHeader(copy)}
                    <div className={style.step}>
                        <SanitizeHtml content={copy.step} />
                    </div>
                    <div className={style.content}>
                        <SanitizeHtml content={copy.content} />
                    </div>
                    <div className={ctaWrapperClass}>
                        {this.getCancel(copy)}
                        <a className={ctaClassName} onClick={this.onCtaClick} href="#0">
                            {copy.cta}
                            {this.getSvgArrow(hasNext)}
                        </a>
                    </div>
                </Tooltip>
            </span>
        );
    }

}

Tour.propTypes = {
    copy: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    step: PropTypes.number.isRequired,
    isTourOpen: PropTypes.bool.isRequired,
    currentStep: PropTypes.number.isRequired,
    totalSteps: PropTypes.number.isRequired,
    duration: PropTypes.number,

    className: PropTypes.string,
    children: PropTypes.node,

    dataTn: PropTypes.string.isRequired,

    onCtaClick: PropTypes.func.isRequired,
    onOpen: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};

Tour.defaultProps = {
    className: '',
    duration: 1000,
    onCtaClick() {},
    onOpen() {},
    onClose() {}
};

module.exports = Tour;



// WEBPACK FOOTER //
// ./assets/js/components/Tour/Tour.jsx